module.exports = __webpack_public_path__ + "static/media/pinterest.9ab41998.svg";